var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("influencer.data"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-3" }, [
            _vm._v(_vm._s(_vm.$t("influencer.data_hint"))),
          ]),
          !_vm.isEdit
            ? _c(
                "b-alert",
                {
                  staticClass: "mb-3 p-1",
                  attrs: { variant: "warning", show: "" },
                },
                [
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("influencer.pending_on_create"))),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "validation-observer",
            { ref: "influencerForm", attrs: { tag: "div" } },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-5/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.name"),
                          "label-for": "name",
                        },
                      },
                      [
                        _c("b-form-input", {
                          staticClass: "required",
                          attrs: {
                            id: "name",
                            type: "text",
                            disabled: _vm.isEdit,
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                        _vm.isEdit
                          ? _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.$t("influencer.name_locked"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-4/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.email"),
                          "label-for": "email",
                        },
                      },
                      [
                        _c("b-form-input", {
                          staticClass: "required",
                          attrs: {
                            id: "email",
                            type: "email",
                            disabled: _vm.isEdit,
                          },
                          model: {
                            value: _vm.model.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "email", $$v)
                            },
                            expression: "model.email",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-3/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.person_type"),
                          "label-for": "person_type",
                        },
                      },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            id: "person_type",
                            options: _vm.personTypeList,
                          },
                          on: { change: _vm.onPersonTypeChange },
                          model: {
                            value: _vm.model.person_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "person_type", $$v)
                            },
                            expression: "model.person_type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full", class: _vm.identityColClass },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.documentLabel,
                          "label-for": "document",
                        },
                      },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.documentLabel,
                            rules: _vm.documentRules,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: _vm.documentMask,
                                        expression: "documentMask",
                                      },
                                    ],
                                    attrs: {
                                      id: "document",
                                      type: "text",
                                      state: errors.length > 0 ? false : null,
                                    },
                                    model: {
                                      value: _vm.model.document,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "document", $$v)
                                      },
                                      expression: "model.document",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.isEdit
                  ? _c(
                      "div",
                      { staticClass: "vx-col sm:w-3/12 w-full" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            name: _vm.$t("influencer.birthdate"),
                            rules: "required|min_age",
                            slim: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("influencer.birthdate"),
                                          "label-for": "birthdate",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "required",
                                          attrs: {
                                            id: "birthdate",
                                            type: "date",
                                          },
                                          model: {
                                            value: _vm.model.birthdate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "birthdate",
                                                $$v
                                              )
                                            },
                                            expression: "model.birthdate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1813376623
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "vx-col w-full", class: _vm.identityColClass },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.slug"),
                          "label-for": "slug",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { id: "slug", type: "text" },
                          model: {
                            value: _vm.model.slug,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "slug", $$v)
                            },
                            expression: "model.slug",
                          },
                        }),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm.$t("influencer.slug_hint"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col w-full", class: _vm.identityColClass },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.level"),
                          "label-for": "level_id",
                        },
                      },
                      [
                        _c(
                          "v-select",
                          {
                            staticClass: "w-full",
                            attrs: {
                              id: "level_id",
                              options: _vm.levels,
                              reduce: function (opt) {
                                return opt.id
                              },
                              label: "name",
                            },
                            model: {
                              value: _vm.model.level_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "level_id", $$v)
                              },
                              expression: "model.level_id",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options",
                              },
                              [_vm._v(_vm._s(_vm.$t("influencer.no_levels")))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-8/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.bio"),
                          "label-for": "bio",
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: { id: "bio", rows: "2" },
                          model: {
                            value: _vm.model.bio,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "bio", $$v)
                            },
                            expression: "model.bio",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-4/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("influencer.groups"),
                          "label-for": "groups",
                        },
                      },
                      [
                        _c(
                          "v-select",
                          {
                            staticClass: "w-full",
                            attrs: {
                              id: "groups",
                              options: _vm.groups,
                              reduce: function (opt) {
                                return opt.id
                              },
                              label: "name",
                              multiple: "",
                            },
                            model: {
                              value: _vm.model.group_ids,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "group_ids", $$v)
                              },
                              expression: "model.group_ids",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options",
                              },
                              [_vm._v(_vm._s(_vm.$t("influencer.no_groups")))]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("influencer.notes_internal"),
                    "label-for": "notes_internal",
                  },
                },
                [
                  _c("b-form-textarea", {
                    attrs: { id: "notes_internal", rows: "2" },
                    model: {
                      value: _vm.model.notes_internal,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "notes_internal", $$v)
                      },
                      expression: "model.notes_internal",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("influencer.notes_internal_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "flex justify-between items-center mb-1" },
            [
              _c("h4", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.$t("influencer.networks"))),
              ]),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-primary" },
                  on: { click: _vm.addProfile },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-25",
                    attrs: { icon: "PlusIcon" },
                  }),
                  _vm._v(_vm._s(_vm.$t("AddNew")) + " "),
                ],
                1
              ),
            ],
            1
          ),
          _c("small", { staticClass: "text-muted d-block mb-3" }, [
            _vm._v(_vm._s(_vm.$t("influencer.networks_hint"))),
          ]),
          !_vm.model.social_profiles.length
            ? _c("div", { staticClass: "text-muted mb-2" }, [
                _vm._v(_vm._s(_vm.$t("influencer.no_networks"))),
              ])
            : _vm._e(),
          _vm._l(_vm.model.social_profiles, function (profile, index) {
            return _c(
              "div",
              { key: index, staticClass: "vx-row items-end mb-1" },
              [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.network") } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.networkList },
                          model: {
                            value: profile.network,
                            callback: function ($$v) {
                              _vm.$set(profile, "network", $$v)
                            },
                            expression: "profile.network",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-3/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.handle") } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text", placeholder: "@perfil" },
                          model: {
                            value: profile.handle,
                            callback: function ($$v) {
                              _vm.$set(profile, "handle", $$v)
                            },
                            expression: "profile.handle",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.followers") } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "number", min: "0" },
                          model: {
                            value: profile.followers,
                            callback: function ($$v) {
                              _vm.$set(profile, "followers", $$v)
                            },
                            expression: "profile.followers",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: { label: _vm.$t("influencer.engagement_rate") },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { type: "number", step: "0.01", min: "0" },
                          model: {
                            value: profile.engagement_rate,
                            callback: function ($$v) {
                              _vm.$set(profile, "engagement_rate", $$v)
                            },
                            expression: "profile.engagement_rate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.verified") } },
                      [
                        _c("b-form-checkbox", {
                          attrs: { switch: "" },
                          model: {
                            value: profile.verified,
                            callback: function ($$v) {
                              _vm.$set(profile, "verified", $$v)
                            },
                            expression: "profile.verified",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/12 w-full mb-1" },
                  [
                    _c("feather-icon", {
                      staticClass:
                        "h-5 w-5 stroke-current text-danger cursor-pointer",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function ($event) {
                          return _vm.removeProfile(index)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm.isEdit
        ? _c("vx-card", { staticClass: "mb-4" }, [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$t("influencer.situation"))),
            ]),
            _c(
              "div",
              { staticClass: "flex items-center gap-2 mb-2" },
              [
                _c(
                  "vs-chip",
                  {
                    staticClass: "text-base",
                    attrs: { transparent: "", color: _vm.statusColor },
                  },
                  [_vm._v(_vm._s(_vm.statusLabel))]
                ),
                _vm.model.rejected_reason
                  ? _c("span", { staticClass: "text-muted small" }, [
                      _vm._v(_vm._s(_vm.model.rejected_reason)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex flex-row gap-2 flex-wrap" },
              [
                _vm.model.status !== "AP"
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "influencers.approve",
                            expression: "'influencers.approve'",
                          },
                        ],
                        attrs: { size: "sm", variant: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.doAction("approve")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("influencer.approve")) + " ")]
                    )
                  : _vm._e(),
                _vm.model.status === "AP"
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "influencers.approve",
                            expression: "'influencers.approve'",
                          },
                        ],
                        attrs: { size: "sm", variant: "outline-warning" },
                        on: {
                          click: function ($event) {
                            return _vm.doAction("suspend")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("influencer.suspend")) + " ")]
                    )
                  : _vm._e(),
                _vm.model.status === "SU"
                  ? _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "influencers.approve",
                            expression: "'influencers.approve'",
                          },
                        ],
                        attrs: { size: "sm", variant: "outline-success" },
                        on: {
                          click: function ($event) {
                            return _vm.doAction("reactivate")
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("influencer.reactivate")) + " "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: "influencers.edit",
                        expression: "'influencers.edit'",
                      },
                    ],
                    attrs: { size: "sm", variant: "outline-primary" },
                    on: {
                      click: function ($event) {
                        return _vm.doAction("refreshLevel")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("influencer.refresh_level")) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "b-form-row",
        { staticClass: "justify-end mt-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.createOrUpdate },
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }